
import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import LanesByDay from "./lanesByDay";
import { DAYS_OF_WEEK } from "app/data/static-load/model";

const tabData = [
    { label: "Monday", value: DAYS_OF_WEEK.MONDAY },
    { label: "Tuesday", value: DAYS_OF_WEEK.TUESDAY },
    { label: "Wednesday", value: DAYS_OF_WEEK.WEDNESDAY },
    { label: "Thursday", value: DAYS_OF_WEEK.THURSDAY },
    { label: "Friday", value: DAYS_OF_WEEK.FRIDAY },
    { label: "Saturday", value: DAYS_OF_WEEK.SATURDAY },
    { label: "Sunday", value: DAYS_OF_WEEK.SUNDAY }
];

const WeekTabs: React.FC = () => {
    return (
        <Tabs defaultIndex={0}>
            <TabList>
                {tabData.map(tab => (
                    <Tab key={tab.value}>{tab.label}</Tab>
                ))}
            </TabList>

            {tabData.map(tab => (
                <TabPanel key={tab.value}>
                    <LanesByDay dayOfWeek={tab.value.toString()} />
                </TabPanel>
            ))}
        </Tabs>
    );
};

export default WeekTabs;

